import ScrollTrigger from 'gsap/dist/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

gsap.to(".js-round-animation", {
    rotation: 90,
    duration: 8,
    ease: "none",
    scrollTrigger: {
        trigger: ".js-prize",
        start: "top 125%",
        end: "top -20%",
        scrub: 2,
    }

})